export default __webpack_public_path__ + "static/media/2SiteCooperando_Desktop_NPS.559ae227.png";